export default __webpack_public_path__ + "static/media/search.bc2178ae.svg";